import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectSortedCapabilitiesBySelectedToGroup } from '../../selectors/capabilities'
import { selectAreaWritable, selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { UpdateGroupPublishingCapabilitiesForm as Component } from './UpdateGroupPublishingCapabilitiesForm'

const mapStateToProps = (state: AppStateType) => ({
  capabilities: selectSortedCapabilitiesBySelectedToGroup(state),
  editable: selectAreaWritable(state, {
    area: AREA_CONSTANTS.SETTINGS_GROUP_CAPABILITIES,
  }),
  canCreateCapability: selectAreaReadable(state, {
    area: AREA_CONSTANTS.SETTINGS_CREATE_CAPABILITY,
  }),
})

export const UpdateGroupPublishingCapabilitiesForm = connect(mapStateToProps)(
  Component
)
